var mode = "production";

var search = window.location.search;
var localStorageValidPeriod = 7; //days

if(document.referrer){
    //only stash referrers if they are external
    if(document.referrer.indexOf(location.hostname) === -1){
        stashToLocalStorage("Middleware_Source", document.referrer);
    }
}

if(isQueryStringPresent(search)){
    //save the query string to local storage
    _console(search,"Middleware_Landing");
    stashToLocalStorage("Middleware_Landing", location.pathname + search);
}

if(validateLocateStorageTimestamp()){
    setHiddenFieldValues();
}

//initialize interest watcher
let forms = document.querySelectorAll("form");
forms.forEach(function(form){
  //console.log("form", form.dataset.formid);
  let labels = form.querySelectorAll('label');
  let interest = labels.forEach(function(lab){
    //console.log('form', form.dataset.formid, ": ", lab.textContent);
    if(lab.textContent == "What are you interested in?*" 
        || lab.textContent == "What are you interested in?" 
        || lab.textContent == "What level of care are you interested in?" 
        || lab.textContent =="What location are you interested in?"
        || lab.textContent =="What location are you interested in?*") {
      //console.log("label found in form: ", form.dataset.formid);
      //find select
      let select = lab.closest('.gfield').querySelector('select');
      //console.log(select,"select to bind");
      select.addEventListener('change', watchInterestSetCareLevel);
    }
  });
});
function watchInterestSetCareLevel(e){
  //console.log("----------WATCHER---------");
  let ele = e.target;
  //console.log(ele, "ele");
  //console.log(ele.querySelector("option:checked").textContent, "selected option");
  let form = ele.closest('form');
  //console.log("watcher form id: ", form.dataset.formid)
  let labels = form.querySelectorAll('label');
  labels.forEach(function(lab){
    if(lab.textContent == "Middleware_Care_Level"){
      //console.log("found value");
      let input = lab.closest(".gfield").querySelector("input")
      input.value = ele.querySelector("option:checked").textContent;
    }
  });
}

function setHiddenFieldValues(){
    let forms = document.querySelectorAll('form');
    forms.forEach(function(form){

        //find hidden fields that match the pattern
        let fields = form.querySelectorAll('.gfield.d-none');
        fields.forEach(function(field){

           // console.log(field,"field");
            let label = field.querySelector('.gfield_label').innerHTML;
           // console.log(label,"label");
            if(label){
                let value = getLocalStorageValue(label);
               // console.log(value,"value");
                if(value){
                    // console.log(field.querySelector('[type="text"]'),"input field");
                    field.querySelector('[type="text"]').setAttribute("value", value);
                }
            }

        });
       
    });
}

function getLocalStorageValue(key){
    let value = localStorage.getItem(key);
    if(value){
        return value;
    }

    return "";
}

function stashToLocalStorage(key, value){
    updateLocalStorageTimestamp();
    localStorage.setItem(key, value);
}

function validateLocateStorageTimestamp(){
    let now = Date.now();
    let then = localStorage.getItem("rebel-utm-timestamp");

    if(now && then){
        let diff = now - then;
        diff = diff / (1000 * 60 * 60 * 24);
        if(diff >= localStorageValidPeriod){
            return false;
        }
    }

    return true;
}

function updateLocalStorageTimestamp(){
    localStorage.setItem('rebel-utm-timestamp', Date.now());
}

function isQueryStringPresent(){ 
    return (search && search.indexOf("utm_source") > -1) ? true : false;
}

function _console(value, text){
    if(mode === 'dev'){
        console.log(value,text);
    }
}